import React from "react";

import { Props } from "./types";
import { DatesPickers } from "./datesPickers";
import styles from "./styles.scss";

function Timestamp({ list, error, readOnly }: Props) {
  return (
    <div className={styles.timestamp}>
      <div className={styles.dates}>
        <DatesPickers
          list={list}
          projectTimezone={list.project.timeZone}
          isInvalid={error.startDateOutOfBound || error.invalidDateRange}
          readOnly={readOnly}
        />
      </div>
    </div>
  );
}

export { Timestamp };
